export default {"src":"/_next/static/media/green_leaf.31e8b2a2.svg","height":162,"width":140,"blurWidth":0,"blurHeight":0};